import React, { ReactNode } from "react";
import { EnvironmentProvider } from "./src/context/environment-context";
import "@fontsource/inter/latin-400.css"; // Specify weight
import "@fontsource/inter/latin-700.css"; // Specify weight

export const wrapRootElement = ({ element }: { element: ReactNode }) => {
  return <EnvironmentProvider>{element}</EnvironmentProvider>;
};
